import _has from 'lodash/has';
import _get from 'lodash/get';

import baseConfig from './locales/base';
import peConfig from './locales/pe';
import coConfig from './locales/co';
import mxConfig from './locales/mx';
import mxLoancoConfig from './locales/mx-loanco';

const data = {
  pe: { ...baseConfig, ...peConfig },
  co: { ...baseConfig, ...coConfig },
  mx: { ...baseConfig, ...mxConfig },
  mx_loanco: { ...baseConfig, ...mxLoancoConfig },
};

const Config = {
  get: key => {
    const fullKey = [process.env.VUE_APP_LOCALE || 'pe', key];

    if(!_has(data, fullKey)) throw new Error(`Key ${key} not found on config`);

    return _get(data, fullKey);
  },
};

export default Config;
